import {useRef} from 'react';
import {useDragScroll} from '../../../common/shared/hooks/useDragScroll';
import {twMerge} from '../../../common/twMerge';
import {List} from '../../atoms/List/List';
import {Text} from '../../atoms/Text/Text';
import {ViewerSettingScrollableItemProps} from './ViewerSettingScrollableItemProps.interface';

export function ViewerSettingScrollableItem({
  isMobile,
  title,
  gapPx = 0,
  children,
  isDisabled,
  className,
  ...props
}: ViewerSettingScrollableItemProps) {
  const listRef = useRef<HTMLUListElement>(null);
  useDragScroll(listRef);
  return (
    <div
      className={twMerge('flex h-32pxr bg-theme-bg-surface', className)}
      {...props}
    >
      <div className="relative h-full">
        <div className="flex h-full items-center bg-theme-bg-surface">
          <Text
            className={twMerge(
              'pr-4pxr text-theme-solid-100',
              isMobile ? 'font-small1' : 'font-medium2',
              isDisabled && 'opacity-30'
            )}
          >
            {title}
          </Text>
        </div>
        <div
          className="absolute top-0 right-[-12px] h-full w-12pxr"
          style={{
            background:
              'linear-gradient(to left, rgb(var(--colors-theme-bg-surface) / 0%), rgb(var(--colors-theme-bg-surface)))',
          }}
        />
      </div>
      <div className="h-full flex-1 overflow-x-hidden scrollbar-hide">
        <div className="flex h-full flex-row items-center justify-end">
          <List
            ref={listRef}
            direction="row"
            gapPx={gapPx}
            className="overflow-x-scroll pl-22pxr scrollbar-hide [&>li]:shrink-0"
          >
            {children}
          </List>
        </div>
      </div>
    </div>
  );
}
